import React from 'react';
import LoadingDataUi from '@app/components/loading';
import moment from 'moment';
import { TableBox } from '../style';
import toast from 'react-hot-toast';

const Table = ({ loading, product_units, handleShow, handleDelete }) => {
  const copyToClipboard = async (id) => {
    try {
      await navigator.clipboard.writeText(id);
      toast.success('Copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };
  return (
    <div>
      {loading ? (
        <LoadingDataUi />
      ) : (
        <TableBox>
          <table>
            <thead className="table_head">
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Date</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody className="table_body">
              {product_units.map((data) => (
                <tr key={data._id}>
                  <td onClick={() => copyToClipboard(data._id)}>{data._id}</td>
                  <td>{data.name}</td>
                  <td>{data.description}</td>
                  <td>{moment(data.created_at).format('LL')}</td>
                  <td>
                    <button onClick={() => handleShow(data)}>Edit</button>
                  </td>
                  <td>
                    <button
                      onClick={() => handleDelete(data._id)}
                      className="delete_btn"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </TableBox>
      )}
    </div>
  );
};

export default Table;
